module.exports = __webpack_public_path__ + "img/icon-bedroom.acd3f824.svg";